import { render, staticRenderFns } from "./AvisoView.vue?vue&type=template&id=084bea72&"
import script from "./AvisoView.vue?vue&type=script&lang=js&"
export * from "./AvisoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports